export default "__VITE_ASSET__rwgQu4QX__"